import { Text } from 'bold-ui'
import { useFlags } from 'config/useFlagsContext'
import { Fragment } from 'react'
import { convertDadosClinicos } from 'view/atendimentos/detail/historico/utils/convertDadosClinicosHistorico'

import HistoricoHeaderEllipsis from '../../../HistoricoHeaderEllipsis'

interface HistoricoDadosClinicosProps {
  isTitleCase?: boolean
  dadosClinicos: string
}

export const HistoricoDadosClinicos = (props: HistoricoDadosClinicosProps) => {
  const { isTitleCase = false, dadosClinicos } = props
  const { PILOTO_CID11_ENABLED, CID11_MTC_ENABLED } = useFlags()
  const isCid11Enabled = PILOTO_CID11_ENABLED || CID11_MTC_ENABLED

  const dadosClinicosConverted = convertDadosClinicos(dadosClinicos)
  const dadosClinicosDisponiveis = isCid11Enabled
    ? dadosClinicosConverted
    : dadosClinicosConverted.filter((dadoClinico) => dadoClinico.terminologia !== '(CID11)')

  return (
    <HistoricoHeaderEllipsis
      tooltipText={dadosClinicosDisponiveis
        .map((dado) => `${dado.descricao.titleCase()} - ${dado.codigo} ${dado.terminologia ?? ''}`)
        .join(' | ')}
    >
      {dadosClinicosDisponiveis.map((dado, index) => (
        <Fragment key={index}>
          <Text fontWeight='bold'>{isTitleCase ? dado.descricao.titleCase() : dado.descricao.toUpperCase()}</Text>
          <Text fontWeight={dado.terminologia ? 'bold' : 'normal'}> - {dado.codigo}</Text>
          {!!dado.terminologia && <Text> {dado.terminologia}</Text>}
          {index < dadosClinicosDisponiveis.length - 1 && <Text> | </Text>}
        </Fragment>
      ))}
    </HistoricoHeaderEllipsis>
  )
}
